module.exports = __webpack_public_path__ + "static/media/sow-login-banner2.2a1c2c5e.png";